//
// pages.js
//
// author: marcio.garcia@newsoftware.com.br
//

export const pages = [
    { id: "HOME", title: "New Software", desc: "Bem-vindo a New Software" },
    { id: "Products", title: "Produtos", desc: "Produtos oferecidos pela New Software" },
    { id: "Services", title: "Serviços", desc: "Serviços prestados pela New Software" },
    { id: "Cases", title: "Casos de sucesso", desc: "Casos de suscesso na New Software" },
    { id: "About", title: "Sobre", desc: "Sobre a New Software" },
    { id: "Contact", title: "Contato", desc: "Fale com a New Software" },
    { id: "Search", title: "Search", desc: "Resultado da pesquisa" },
    { id: "PrivacyPolicy", title: "Politica de Privacidade", desc: "PP" },
    { id: "TermsConditions", title: "Termos e condições ", desc: "Termos e condições de uso de site New Software" }
];

